if (!customElements.get('responsive-video-banner')) {
  class ResponsiveVideoBanner extends HTMLElement {
    constructor() {
      super();
      this.video = null;
      this.source = null;
      this.mobileVideo = null;
      this.desktopVideo = null;
      this.breakpoint = 768;
      this.resizeTimeout = null;
      this.lastIsDesktop = null; // Track state
      this.handleResize = this.debouncedResize.bind(this);
      this.handleVideoCanPlay = this.onVideoCanPlay.bind(this);
    }

    connectedCallback() {
      this.video = this.querySelector('video');
      this.source = this.video?.querySelector('source');

      if (!this.video || !this.source) return;

      const videoData = this.getAttribute('data-video');
      const videoBreakpointData = this.getAttribute('data-video-breakpoint');

      if (videoData) {
        this.mobileVideo = JSON.parse(videoData.replace(/&quot;/g, '"'));
      }
      if (videoBreakpointData) {
        this.desktopVideo = JSON.parse(videoBreakpointData.replace(/&quot;/g, '"'));
      }

      this.setupLazyLoad();
      window.addEventListener('resize', this.handleResize);
      this.video.addEventListener('canplay', this.handleVideoCanPlay);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.video?.removeEventListener('canplay', this.handleVideoCanPlay);
    }

    updateVideoSource(force = false) {
      const isDesktop = window.innerWidth >= this.breakpoint;

      // Only update if the screen type changes OR forced
      if (this.lastIsDesktop !== isDesktop || force) {
        this.lastIsDesktop = isDesktop;

        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        const networkSlow = connection ? ['slow-2g', '2g', '3g', 'slow-4g'].includes(connection.effectiveType) : false;

        const videoData = isDesktop ? this.desktopVideo : this.mobileVideo;
        const bestSource = this.pickBestSource(videoData?.sources || [], networkSlow);

        if (bestSource && this.source.src !== bestSource) {
          this.source.src = bestSource.startsWith('http') ? bestSource : 'https:' + bestSource;
          this.video.load();
        }
      }
    }

    pickBestSource(sources, networkSlow) {
      if (!sources.length) return null;

      if (networkSlow) {
        const sd = sources.find((src) => src.height <= 480 && src.format === 'mp4');
        if (sd) return sd.url;
      }

      const hd = sources.find((src) => src.height >= 720 && src.format === 'mp4');
      if (hd) return hd.url;

      const md = sources.find((src) => src.height <= 720 && src.format === 'mp4');
      if (md) return md.url;

      const fallback = sources.find((src) => src.format === 'mp4');
      return fallback ? fallback.url : null;
    }

    debouncedResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.updateVideoSource(), 200);
    }

    onVideoCanPlay() {
      const picture = this.querySelector('picture');
      if (picture) {
        picture.classList.add('hidden');
        // picture.style.opacity = '0';
        // picture.style.transition = 'opacity 0.5s ease';
        // setTimeout(() => {
        //   picture.style.display = 'none';
        // }, 500);
      }
    }

    setupLazyLoad() {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.updateVideoSource(true); // force initial load
              obs.unobserve(this.video);
            }
          });
        },
        {
          rootMargin: '200px',
          threshold: 0.1,
        }
      );

      observer.observe(this.video);
    }
  }

  customElements.define('responsive-video-banner', ResponsiveVideoBanner);
}
